module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "services"
    }
  }, [_c('h2', [_vm._v(" Services à l'accueil ")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Conseil "), _c('strong', [_vm._v("vétérinaire")]), _vm._v(" gratuit")]), _vm._v(" "), _c('p', [_vm._v("Nous vous écoutons")]), _vm._v(" "), _c('p', [_vm._v("Nous vous fournissons une solution globale personnalisée")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Vente")]), _vm._v(" "), _c('p', [_vm._v("Nous ne proposons que des "), _c('strong', [_vm._v("croquettes")]), _vm._v(" et "), _c('strong', [_vm._v(" des antiparasitaires")]), _vm._v(" haut de gamme que nous avons étudiés\n           et testés")]), _vm._v(" "), _c('p', [_vm._v("Nous vous garantissons sur tous les produits le prix le plus bas du marché")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Aliments")]), _vm._v(" : Royal canin,\n         Hill's, Virbac,\n         Proplan, Specific\n       ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Antiparasitaires")]), _vm._v(" : "), _c('strong', [_vm._v("Collier")]), _vm._v(" scalibor,\n         Seresto "), _c('strong', [_vm._v("comprimés")]), _vm._v(" bravecto,\n         Nexguard, Credelio\n       ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Pipettes")]), _vm._v(" : Advantix, Stronghold, Frontline")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Vermifuges")]), _vm._v(": Drontal, Milbemax, Eqvalan, Panacur")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a0cc157"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fr/ServicesHome.vue
// module id = 138
// module chunks = 0